import { isValidElement, memo } from "react";
import { View } from "react-native";
import { CoreListProps } from "../../types";

const VirtualListHeader = <T extends any>({
	ListHeaderComponent,
	ListHeaderComponentStyle,
}: Pick<CoreListProps<T>, "ListHeaderComponent" | "ListHeaderComponentStyle">) => {
	return ListHeaderComponent ? (
		<View style={ListHeaderComponentStyle}>
			{isValidElement(ListHeaderComponent) ? ListHeaderComponent : <ListHeaderComponent />}
		</View>
	) : null;
};
export default memo(VirtualListHeader);
